import React from "react";
import { Button } from "reactstrap";

export function getSynchronizationReportRecordsTableColumns(items)
{
    const tailColumns = ['ErrorDetails'];
    const tailColumnSet = new Set(tailColumns);
    const complexProperties = ['ValidationResults'];
    const complexPropertySet = new Set(complexProperties);
    const propertySet = new Set();
    const propertyList = [];
    for (const item of items)
    {
        for (const property of Object.entries(item).map(([key]) => key).filter(property => !complexPropertySet.has(property) && !tailColumnSet.has(property)))
        {
            if (!propertySet.has(property))
            {
                propertySet.add(property);
                propertyList.push(property);
            }
        }
        for (const complexProperty of complexProperties)
        {
            if (Object.prototype.hasOwnProperty.call(item, complexProperty))
            {
                for (const property of Object.keys(item[complexProperty]))
                {
                    const propertyName = `${complexProperty}.${property}`;
                    if (!propertySet.has(propertyName))
                    {
                        propertySet.add(propertyName);
                        propertyList.push(propertyName);
                    }
                }
            }
        }
        for (const endProperty of tailColumns)
        {
            if (!propertySet.has(endProperty))
            {
                propertySet.add(endProperty);
                propertyList.push(endProperty);
            }
        }
    }
    return propertyList;
}

export function ExportToClipboardButton({ items })
{
    const handleExport = async () =>
    {
        if (!items?.length) { return; }
        const escape = value => `"${String(value ?? '').replace(/"/g, '""')}"`;
        const columns = getSynchronizationReportRecordsTableColumns(items);
        const columnValue = (item, column) =>
        {
            const [main, sub] = column.split('.');
            const value = sub ? item?.[main]?.[sub] : item?.[column];
            return escape(value);
        };
        const rows = [columns.join('\t'), ...items.map(item => columns.map(column => columnValue(item, column)).join('\t'))];
        const csv = rows.join('\n');
        await navigator.clipboard.writeText(csv);
    };
    return <Button className="mb-3" onClick={handleExport}>Kopiuj do schowka jako CSV</Button>;
}

export function SynchronizationReportRecordsTable({ items })
{
    const columns = getSynchronizationReportRecordsTableColumns(items);
    const element =
    <div className="table-responsive">
        <ExportToClipboardButton items={items} />
        <table className="table-sm table-bordered report-items-table">
            <thead>
                <tr>
                    {columns.map(col => <th key={col}>{col}</th>)}
                </tr>
            </thead>
            <tbody>
                {items.map((item, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map(col => {
                            const [main, sub] = col.split('.');
                            const value = sub ? item?.[main]?.[sub] : item?.[col];
                            return <td key={col}>{String(value ?? '')}</td>;
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>;
    return element;
}